import React from 'react'

import transformLink from '~/utils/transformLink'

import ButtonArrow from '~/components/core/buttonArrow'
import Image from '~/components/core/Image'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'
import { ImageNewNew } from '~/components/core/ImageNewNew'
// import { LaboLeaf } from '~/icons/LaboLeaf';
// import { LaboPipe2 } from '~/icons/LaboPipe2';
// import { LaboHelmet } from '~/icons/LaboHelmet';

import leaf from '~/icons/labo-leaf.svg'
import pipe from '~/icons/labo-pipe2.svg'
import helmet from '~/icons/labo-helmet.svg'

const ImgText = ({ item, pos }) => {
  const isEven = pos % 2 === 0
  const ctaColor = isEven ? 'green' : 'blue'

  const cta = item.cta ? (item.cta.fields ? item.cta.fields : item.cta) : null
  // const content = item.content.raw ?? item.content
  let url = null
  let external = false
  let contentType = false

  if (cta) {
    let link = transformLink(cta, true, false)
    url = link.url
    external = link.external
    contentType = link.contentTypeContentful
  }

  let icon = pipe.id

  if (pos === 2) {
    icon = leaf.id
  } else if (pos === 3) {
    icon = helmet.id
  }

  return (
    <div className={`row hp-infos__item-${pos}`}>
      <div
        className={`col-12 md-col-6 lg-col-4 lg-col-offset-1 xl-col-3 ${!isEven ? 'xl-col-offset-2' : ''} self-center relative pt-8`}
      >
        <span
          className={`hp-infos__label ${isEven ? 'hp-infos__label--right' : ''}`}
        >
          <svg
            className={`icon-light-purple ${pos === 2 ? 'mr-1' : 'mr-4'}`}
            width="48"
            height="48"
          >
            <use xlinkHref={`#${icon}`} />
          </svg>
          <span>{item.label}</span>
        </span>

        <h3 className="title-2-bold">{item.title}</h3>

        <Wysiwyg classes="mt-7 md:mt-8" document={item.content} />

        {cta && (
          <div className="text-center md:text-left mt-6">
            <ButtonArrow
              text={cta.label}
              link={url}
              external={external}
              contentType={contentType}
              color={ctaColor}
            />
          </div>
        )}
      </div>
      <div
        className={`col-12 md-col-6 lg-col-6 order-first ${!isEven ? 'md:order-last lg-col-offset-1' : ''}`}
      >
        <Image
          classes={`hp-infos__img w-full ${isEven ? 'hp-infos__img--left' : ''}`}
          width="720"
          height="560"
          sizes={{ 415: [354, 270], 767: [707, 540], 1023: [480, 385] }}
          image={item.image}
          isBgImage
        />
      </div>
    </div>
  )
}

export default ImgText
